<template>
    <modal-base class="fzg-qrcode-modal" @hide-modal="hideModal">
        <template slot="header">
        </template>
        <template slot="content">
          <img class="qrcode" src="../../assets/img2/mobile/common/qr_01.jpg">
          <!-- <img class="qrcode" src="../../assets/img2/mobile/common/qr_02.jpg"> -->
          <img class="qrcode" src="https://static-image.xfz.cn/1697974278002/qr_m.jpg" width="198px">
        </template>
    </modal-base>
</template>

<script>
import ModalBase from '../widgets/ModalBase.vue'

export default {
    mixins: [],
    props: [''],
    data () {
      return {
      }
    },
    methods: {
      hideModal () {
        this.$emit('hide-modal')
      },
    },
    mounted(){
    },
    components:{ModalBase}
}
</script>

<style lang="scss">
.fzg-qrcode-modal {
  .modal {
    border-radius: 8px;
    width: 80%;
    height: 660px;
    margin: 30px auto;
    min-width: 380px !important;
    // background: #232323 !important;
    header {
        height: 50px;
        line-height: 50px;
        font-size: 20px;
        // border-bottom: 1px solid #c7cfdd;
        margin-right: 0 !important;
        i.icon-close {
            width: 44px !important;
            height: 44px !important;
            margin-top: 10px !important;
            background: {
                image: url("../../assets/img/pc/circle-close.png");
                repeat: no-repeat;
                size: 100%;
            }
        }
        .training-modal-title {
          color: white;
          position: relative;
          // border: 1px solid #ccc;
          height: 100px;
          float: left;
          width: 800px;
          overflow: hidden;
          img {
            position: absolute;
            display: block;
            width: 80px;
            top: 20px;
            left: 10px;
          }
          span {
            position: absolute;
            display: block;
            top: 36px;
            left: 40px;
          }
        }
    }
  }
  .content {
    clear: both;
    font-size: 14px;
    color: white;
    font-size: 14px;
    // height: 400px;
    // line-height: 3;
    padding: 0px 40px 80px;
    margin: 0 30px;
    white-space: pre-wrap;
    overflow: scroll;
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .qrcode {
      width: 215px;
      margin: 0 auto;
      display: block;
      // border: 1px solid red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// QrcodeModal.vue?48f5d3f0